import React from 'react'
import Book1 from '../../../images/activity/inviteNew/book1.png'
import Book2 from '../../../images/activity/inviteNew/book2.png'
import Book3 from '../../../images/activity/inviteNew/book3.png'


export default class InviteAccepted extends React.Component {
    render() {
        let {inviter} = this.props
        return (
            <div className="invite-accepted">
                <div className="invite-accepted-header">
                    <span className="invite-accepted-header__line"/>
                    <span className="invite-accepted-header__text">好友动态</span>
                    <span className="invite-accepted-header__line"/>
                </div>
                <div className="invite-accepted-content">
                    <div className="invite-accepted-item weui-flex">
                        <div className="invite-accepted__image">
                            <img className="invite-accepted__avatar" src={inviter.small_avatar_url}/>
                        </div>
                        <div className="invite-accepted__content">
                            <p className="invite-accepted__text">{inviter.nickname}正在收听这些课程</p>
                            <div className="invite-accepted__books">
                                <img className="invite-accepted__book__item" src={Book1}/>
                                <img className="invite-accepted__book__item" src={Book2}/>
                                <img className="invite-accepted__book__item" src={Book3}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/AppPage/InviteNewUser/InviteAccepted.js